/* eslint-disable react/style-prop-object */
import React, { useContext } from "react";
import Close from "../../../Helpers/CloseBtn/Close";
import { popupcontext } from "../../../../context/Popupscontext";
import { useMap } from "react-leaflet";
import { isRTL } from "../../../../utils";
export default function ObjectSelectedHead({ values, device , setimei}) {
  let { handleClose ,setObjectselect } = useContext(popupcontext);
  const map = useMap();
  const lang = localStorage.getItem("lang") || "en";
  return (
    <>
      <div className="street-view-head">
        <div className="street-view-head-inf">
          <img
            src={`${process.env.PUBLIC_URL}/assets/Double-arrow.svg`}
            alt="Double-Arrow"
            onClick={() => {
              setObjectselect(false);
            }}
            role="button"
            style={{transform: isRTL && "rotate(180deg)"}}
          />
          <p className="ms-2 me-3 my-0 fs-16 fw-600">{values?.name}</p>
          <div
            className={
              device?.status === "online"
                ? "status-online"
                : "status-offline"
            }
          ></div>
        </div>
        <Close
          style="close close-32"
          close={() => {
            handleClose("objectSelected");
            setimei(null)
            map.scrollWheelZoom.enable();
            map.dragging.enable();
          }}
          img="Close"
        />
      </div>
    </>
  );
}